/* @flow */

import * as React from 'react';
import './modal-header.module.css';

type Props = {
    children?: React.Node,
    as: string,
};

ModalHeader.defaultProps = {
    as: 'div',
};

export function ModalHeader({children, as: Tag}: Props) {
    return <Tag styleName='modal-header'>{children}</Tag>;
}
